module.exports = __webpack_public_path__ + "static/9-5958109addca5907017961b50c27f0b7.png";